<template>
  <div class="skillVue">
    <div class="o-main-content-area c-responsive-fixwidth pad-adjust">
        <!-- Heading Section -->
        <div class="row">
            <div class="col-md-3" :class="skillComponent== 2?'p-0':'p-3'">
                <!-- <p class="u-back" v-if="skillComponent == 1 || skillComponent == 2"><a href="javascript: void(0)" @click="goToSkills()"><i class="fa fa-chevron-left"></i> Back</a></p> -->
                <div class="text-right" v-if="skillComponent == 2">
                    <ul class="o-filter-area">
                        <li class="o-search-field" v-if="skillComponent == 2">
                            <label for="rate_table" class="mt-5">Rate Table:</label>
                        </li>
                        <li class="o-search-field" v-if="skillComponent == 2">
                            <div class="input-group stylish-input-group mr-10">
                                <div class="common-label-input--modalwidth o-custom-dropdown">
                                    <select v-model="selectedRateId" @change="getSkills()" class="form-control" id="rate_table" name="rate_table" placeholder="Select Rate Table" data-vv-delay="500">
                                        <option value="">--- Select ---</option>
                                        <option v-for="(rate,index) in rates" :key="index" :value="rateTablesOn ? rate.table_id : rate.id">{{rate.name}}</option>
                                    </select>
                                    <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                </div> 
                            </div>
                        </li>
                    </ul>
                </div>
                <h1 class="h1" v-if="skillComponent != 2">{{(this.skillComponent == 1)?"Archived Skills":(this.skillComponent == 2)?"Rate Tables":"Skills"}}</h1>
            </div>
            <div class="col-md-9" :class="skillComponent== 2?'text-left p-0':'text-right'">
                <ul class="o-filter-area">
                    <li class="o-search-field" v-if="skillComponent == 2">
                        <label for="rate_table" class="mt-5">Base Rate:</label>
                    </li>
                    <li class="o-search-field" v-if="skillComponent == 2">
                        <div class="input-group stylish-input-group">
                            <input type="text" class="form-control" placeholder="Base Rate" v-model="base_rate">
                        </div>
                    </li>
                    <li class="o-search-field" v-if="skillComponent == 2">
                        <div class="input-group stylish-input-group mr-10">
                            <!-- <button class="btn btn-primary" type="button" @click="updateSkillBaseRate()">Update</button> -->
                            <a id="update_all" href="javascript: void(0)" @click="updateSkillsBaseRate()" class="c-solid-btn btn-save-skill" :class="{'greyBg': userRoleSlug=='auditor'}">Update All</a>
                        </div>
                    </li>
                    <!-- #2081 — per-client tables (flag on only): add / rename / reorder / archive / restore. #2083: no employer controls here — an employer's default rate table is set on the Employer screen -->
                    <li class="o-search-field" v-if="skillComponent == 2 && rateTablesOn && userRoleSlug != 'auditor'">
                        <div class="input-group stylish-input-group mr-10">
                            <a id="manage_rate_tables" href="javascript: void(0)" @click="openManageTables()" class="c-common-btn c-common-btn--inverse-icon"><i class="fa fa-cog" aria-hidden="true"></i> Manage Tables</a>
                        </div>
                    </li>
                    <li class="o-search-field">
                        <div class="input-group stylish-input-group">
                            <input type="text" class="form-control" placeholder="Search" v-model="searchSkill" v-on:input="searchSkillMethod()">
                            <span class="input-group-addon">
                                <button type="submit">
                                <span class=""><i class="fa fa-search" aria-hidden="true"></i></span>
                            </button>
                            </span>
                        </div>
                    </li>
                    <li v-if="skillComponent == 0 || skillComponent == 2">
                        <a href="javascript: void(0)" @click="goToArchiveSkills()" class="c-common-btn c-common-btn--inverse-icon"><i class="fa fa-archive" aria-hidden="true"></i> Archived Skills</a>
                    </li>
                    <li v-if="skillComponent == 1 || skillComponent == 2">
                        <a href="javascript: void(0)" @click="goToSkills()" class="c-common-btn c-common-btn--inverse-icon"><i class="fa fa-wrench" aria-hidden="true"></i> Skills</a>
                    </li>
                    <li v-if="getPower('addSkill')&&!skillComponent">
                        <a href="javascript: void(0)" class="c-common-btn c-common-btn--green" @click="addSkillModal()"><i class="fa fa-plus" aria-hidden="true"></i> Add New Skill</a>
                    </li>
                    <li v-if="getPower('ImportCSV')&&!skillComponent">
                        <a href="javascript: void(0)" @click="importCSV()" class="c-common-btn c-solid-btn--blue"><i class="fa fa-upload" aria-hidden="true"></i> Skills CSV Import</a>
                    </li>
                    <li v-if="skillComponent == 0 || skillComponent == 1">
                        <a href="javascript: void(0)" @click="goToRateTable()" class="c-common-btn c-common-btn--inverse-icon"><i class="fa fa-table" aria-hidden="true"></i>Rate Tables</a>
                    </li>                        

                </ul>
            </div>
        </div>
        <!-- /Heading Section -->
    </div>
    <SkillResults :myProp="search_query" :rates="rates" v-if="skillComponent == 0" />
    <ArchivedSkills :myProp="search_query" v-if="skillComponent == 1" />
    <RateTable :myProp="search_query" :rateId="selectedRateId" :rates="rates" v-if="skillComponent==2 && selectedRateId" />
    <div v-else-if="skillComponent==2">Plese Wait and select a rate table on top</div>

   <!-- #2081 — Manage rate tables (flag on only; the API refuses anyone but Client Admin / Power User / Super Admin) -->
   <modal name="manage-rate-tables" height="auto" width="780" :scrollable="true" class="modal-dialog modal-sm">
     <div class="modal-add-newJob" tabindex="-1" role="dialog">
        <div role="document">
            <div class="modal-content o-common-modal-content">
                <div class="modal-header u-no-border text-center">
                    <button @click="closeManageTables()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title">Rate Tables</h4>
                </div>
                <div class="modal-body c-common-box-shadow o-modal-body" v-loading.lock="manage.busy" id="manage_rate_tables_body">
                    <p class="err-msg rt-error" v-if="manage.error" id="rt_error">{{ manage.error }}</p>
                    <div class="row">
                        <div class="col-sm-12 o-modal-field-area">
                            <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                <label class="common-label-text common-label-text--modalwidth">New Table:</label>
                            </div>
                            <div class="col-sm-6 o-left-no-padding o-modal-form-field">
                                <label class="common-label-input--modalwidth o-custom-dropdown">
                                    <input type="text" class="form-control" placeholder="Alias" maxlength="60" v-model="manage.newAlias" id="rt_new_alias" @keyup.enter="addTable()">
                                </label>
                            </div>
                            <div class="col-sm-3 o-modal-form-field">
                                <a href="javascript: void(0)" id="rt_add" class="c-solid-btn c-solid-btn--green btn-save-skill" @click="addTable()"><i class="fa fa-plus" aria-hidden="true"></i> Add</a>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="table-responsive o-no-margin-bottom">
                                <table class="table table-bordered o-demo-table o-no-margin-bottom" id="rt_live_tables">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Alias</th>
                                            <th>Order</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(t,i) in manage.live" :key="t.id" class="rt-row" :data-table-id="t.id">
                                            <td>{{ i + 1 }}</td>
                                            <td>
                                                <input type="text" class="form-control rt-alias" maxlength="60" v-model="t.alias" :id="'rt_alias_' + t.id" @keyup.enter="renameTable(t)">
                                                <a href="javascript: void(0)" class="c-solid-btn btn-save-skill rt-rename" v-if="t.alias !== t.saved_alias" @click="renameTable(t)">Rename</a>
                                            </td>
                                            <td class="text-center">
                                                <a href="javascript: void(0)" class="rt-up" :class="{'rt-disabled': i === 0}" @click="moveTable(i, -1)" title="Move up"><i class="fa fa-arrow-up" aria-hidden="true"></i></a>
                                                <a href="javascript: void(0)" class="rt-down" :class="{'rt-disabled': i === manage.live.length - 1}" @click="moveTable(i, 1)" title="Move down"><i class="fa fa-arrow-down" aria-hidden="true"></i></a>
                                            </td>
                                            <td class="text-center">
                                                <a href="javascript: void(0)" class="c-common-btn c-common-btn--inverse-icon rt-archive" @click="archiveTable(t)"><i class="fa fa-archive" aria-hidden="true"></i> Archive</a>
                                            </td>
                                        </tr>
                                        <tr v-if="!manage.live.length"><td colspan="4">No rate tables yet — add one above.</td></tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="table-responsive o-no-margin-bottom rt-archived" v-if="manage.archived.length" id="rt_archived">
                                <p class="o-rowtable-text"><strong>Archived:</strong></p>
                                <table class="table table-bordered o-demo-table o-no-margin-bottom" id="rt_archived_tables">
                                    <tbody>
                                        <tr v-for="t in manage.archived" :key="'ar' + t.id" class="rt-archived-row" :data-table-id="t.id">
                                            <td class="rt-archived-item">{{ t.alias }}</td>
                                            <td class="text-center">
                                                <a href="javascript: void(0)" class="c-common-btn c-common-btn--inverse-icon rt-restore" @click="restoreTable(t)" title="Back to the live tables, last in the order"><i class="fa fa-undo" aria-hidden="true"></i> Restore</a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer text-center">
                    <ul class="o-filter-area">
                        <li>
                            <a href="javascript: void(0)" @click="closeManageTables()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Close</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
   </modal>

   <modal name="add-skill"  height="auto" :scrollable="true" class="modal-dialog modal-sm">
     <div class="modal-add-newJob" tabindex="-1" role="dialog">
        <div  role="document">
            <div class="modal-content o-common-modal-content">
                <div class="modal-header u-no-border text-center">
                    <button @click="closeAddSkill()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title">Add Skill</h4>
                </div>
                <div class="modal-body c-common-box-shadow o-modal-body">
                    <div class="row">
                        <div class="col-sm-12 o-modal-field-area">
                            <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                <label class="common-label-text common-label-text--modalwidth">Skill Name:</label>
                            </div>
                            <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                <label class="common-label-input--modalwidth o-custom-dropdown">
                                  <input type="text" class="form-control" placeholder="Text Input"  v-validate="{required: true}" name="name" v-model="addSkill.name">
                               <span v-show="errors.has('name') && this.validation_err == 1" class="err-msg">{{ errors.first('name') }}</span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 o-modal-field-area">
                            <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                <label class="common-label-text common-label-text--modalwidth">Sort Priority:</label>
                            </div>
                            <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                <label class="common-label-input--modalwidth o-custom-dropdown">
                                          <input type="text" class="form-control" placeholder="Text Input" v-model="addSkill.priotiy">
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 o-modal-field-area">
                            <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                <label class="common-label-text common-label-text--modalwidth">Description:</label>
                            </div>
                            <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                <label class="common-label-input--modalwidth o-custom-dropdown">
                                  <textarea placeholder="Text Area" v-model="addSkill.description" class="form-control" rows="6" v-validate="{required: true}" name="description"></textarea>
                                    <span v-show="errors.has('description') && this.validation_err == 1" class="err-msg">{{ errors.first('description') }}</span>
                                    </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer text-center">
                    <ul class="o-filter-area">
                        <li>
                            <a href="javascript: void(0)" @click="closeAddSkill()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                        </li>
                        <li>
                            <a href="javascript: void(0)" @click="addNewSkill()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-save"></i> Save</a>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
    </div>
   </modal>
   <modal name="import-csv-modal" height="auto" :scrollable="true" class="modal-dialog modal-sm">
     <div class="modal-add-newJob" tabindex="-1" role="dialog">
        <div  role="document">
            <div class="modal-content o-common-modal-content">
                <div class="modal-header u-no-border text-center">
                    <button @click="closeimportCSV()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title">Import CSV</h4>
                </div>
                <div class="modal-body c-common-box-shadow o-modal-body" v-loading.this.lock="lockCSV">

                    <div class="row">
                        <div class="col-sm-12">
                            <h2 class="h2 text-center">Please Read Before Upload</h2>
                            <div class="row">
                                <div class="col-sm-12">
                                    <hr class="o-modal-separetor" />
                                </div>
                            </div>
                            <div class="o-accordion-subtext o-rowtable-text form-inline o-rowtable-text">
                                <p class="ps1">To prepare your CSV for the import, you must ensure the following:</p>
                                <ul class="skill-details">
                                    <li>1. The CSV must not contain blank rows which separate valid records.</li>
                                    <li>2. The first row must consist of the field names related to the data</li>
                                    <li>3. Acceptable format for upload: <strong>ods,xlsx,xls.csv</strong></li>
                                </ul>
                            </div>
                            <div class="o-accordion-subtext o-rowtable-text form-inline o-rowtable-text">
                                <div class="table-responsive o-no-margin-bottom">
                                  <table class="table table-bordered o-demo-table o-no-margin-bottom">
                                    <thead>
                                      <tr>
                                        <th>Name</th>
                                        <th>Priority</th>
                                        <th>Description</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td>Carpenter</td>
                                        <td>2</td>
                                        <td>Lorem Ipsum</td>
                                      </tr>
                                      <tr>
                                        <td>Electrician</td>
                                        <td>3</td>
                                        <td>Lorem Ipsum</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                                <div class="o-emp-csv-download"><strong>- OR -</strong> Download sample <a href="static/assets/download/sample-skill.csv" download class="o-csv-download"><i class="fa fa-download" aria-hidden="true"></i></a></div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <hr class="o-modal-separetor" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="common-label-input--modalwidth o-upload-file upload-btn-wrapper">
                                <button class="btn c-common-btn c-common-btn--small c-common-btn--green o-csv-upload">Choose File</button>
                                <input class="" type="file" name="myfile" @change="uploadCSV($event)"/>
                                <!-- <span>file name</span> -->
                            </div>
                        </div>
                    </div>

                    <!--
                    <div class="row">
                        <div class="col-sm-12 o-modal-field-area">
                            <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                <label class="common-label-text common-label-text--modalwidth">Sort Priority:</label>
                            </div>
                            <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                <label class="common-label-input--modalwidth o-custom-dropdown">
                                          <input type="text" class="form-control" placeholder="Text Input" v-model="addSkill.priotiy">
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 o-modal-field-area">
                            <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                <label class="common-label-text common-label-text--modalwidth">Description:</label>
                            </div>
                            <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                <label class="common-label-input--modalwidth o-custom-dropdown">
                                  <textarea placeholder="Text Area" v-model="addSkill.description" class="form-control" rows="6" v-validate="{required: true}" name="description"></textarea>
                                    <span v-show="errors.has('description') && this.validation_err == 1" class="err-msg">{{ errors.first('description') }}</span>
                                    </label>
                            </div>
                        </div>
                    </div>
                    -->
                </div>
                <div class="modal-footer text-center">
                    <ul class="o-filter-area">
                        <li>
                            <a href="javascript: void(0)" @click="closeimportCSV()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                        </li>
                        <!-- <li>
                            <a @click="" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-save"></i> Save</a>
                        </li> -->
                    </ul>
                </div>
            </div>
            <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
    </div>
   </modal>

  </div>
</template>
<script>
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import service from '../../services.js';
    import { bus } from '../../main';
    import SkillResults from './skillList';
    import ArchivedSkills from './archiveSkills';
    import RateTable from './rateTable';
    import dateTimeConvert from '../../timeConvert&Compare';
    import * as rt from '../../rateTables';   // #2081
    export default {
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userID: 'userID',
                userClientID: "userClientID",
                userRoleSlug: 'userRoleSlug'
            })
        },
        components: {
            'SkillResults': SkillResults,
            'ArchivedSkills': ArchivedSkills,
            'RateTable': RateTable
        },
        data() {
            return {
                base_rate: '',
                selectedRateId: '1',
                rates: [],
                // #2081 — true only when getRates answers B's flag-on feed (rows carry table_id)
                rateTablesOn: false,
                manage: {
                    busy: false,
                    error: '',
                    live: [],
                    archived: [],
                    newAlias: ''
                },
                skills: [],
                total: 0,
                storeMore: [],
                page_no: 3,
                sortSkill: 'name',
                // addSkill:{'name':"",'priotiy':"",'description':"",'client_id':0},
                addSkill: {
                    'name': "",
                    'description': "",
                    'client_id': 0
                },
                next_page: "",
                search_query: "",
                validation_err: 0,
                status_message: "",
                skill_id: 0,
                skill_key: 0,
                presentSkill: [],
                presentEmployees: [],
                lockEmployees: false,
                assignable_employees: [],
                archivedSkill: [],
                skillComponent: 0, //0 for all and 1 for archived skills
                searchSkill: '',
                lockCSV: false
            }
        },
        mounted() {
            this.getRates();
            this.getSkills();
        },
        created() {
            bus.$on('changeBaseRate', (amount) => {
                this.base_rate = amount;
                this.searchSkill = '';
            });
        },
        beforeMount() {
            this.addSkill.client_id = this.userClientID;
        },
        watch: {
            // selectedRateId(newVal) {
            //     this.getAllSkillS();
            // }
        },
        methods: {
            getRates() {
                service.get('getRates', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then((res) => {
                    this.rates = res.data.result;
                    // console.log(this.rates);
                    // #2081 — with the flag on the selector holds a TABLE id (B's getRates
                    // carries table_id); master's '1' default is not one, so land on the
                    // first live table. Flag off: nothing here runs.
                    this.rateTablesOn = rt.tablesOn(this.rates);
                    if (this.rateTablesOn) {
                        const tables = rt.liveTables(this.rates);
                        if (!tables.some((t) => t.table_id === this.selectedRateId)) {
                            this.selectedRateId = tables.length ? tables[0].table_id : '';
                        }
                        this.refreshBaseRate();
                    }
                }).catch((err) => {
                    console.log(err);
                });
            },
            updateSkillsBaseRate() {
                if(this.userRoleSlug=='auditor') {
                    return;
                }
                let params = {
                    skill: 'all',
                    amount: this.base_rate,
                    rate_id: this.selectedRateId
                }
                if (this.rateTablesOn) {
                    // #2081 — B's setBaseRate takes the table itself; it writes the table's
                    // amounts AND, for a back-filled table, the legacy rows.
                    params = { skill: 'all', amount: this.base_rate, table_id: this.selectedRateId };
                }
                service.post('skill/setBaseRate', params, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                })
                .then((res) => {
                    this.status_message = res.data.status_message;
                    this.$notify({
                        title: this.$t('success'),
                        message: 'Skill Updated Successfully.',
                        type: 'success'
                    });
                    let tempRateId = this.selectedRateId;
                    this.selectedRateId = 0;
                    setTimeout(() => {
                        this.selectedRateId = tempRateId;
                    }, 200);
                   
                }).catch((err) => {
                    console.log(err);
                })             
            },
            getPower(data) {
                return dateTimeConvert.checkAccess(data);
            },
            addNewSkill() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.validation_err = 0;

                        service.post('skill', this.addSkill, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID,
                        })
                        .then((res) => {
                            this.status_message = res.data.status_message;
                            setTimeout(() => {
                                this.$modal.hide('add-skill');
                            }, 500);
                            this.$notify({
                                title: this.$t('success'),
                                message: 'Skill Added Successfully.',
                                type: 'success'
                            });
                            this.search_query = {
                                'test': 1
                            };

                        }).catch((err) => {
                            console.log(err);
                        })

                    } else
                        this.validation_err = 1;

                });
            },
            addSkillModal() {
                this.addSkill['name'] = "";
                this.addSkill['description'] = "";
                //this.addSkill['priotiy']="";
                this.status_message = "";
                this.$modal.show('add-skill');
            },
            closeAddSkill() {
                this.$modal.hide('add-skill');
            },
            goToArchiveSkills() {
                this.searchSkill = '';
                this.skillComponent = 1;
            },
            goToRateTable() {
                this.searchSkill = '';
                this.skillComponent = 2;
            },
            goToSkills() {
               this.searchSkill = '';
                this.skillComponent = 0;
            },
            importCSV() {
                this.$modal.show('import-csv-modal');
            },
            closeimportCSV() {
                this.$modal.hide('import-csv-modal');
            },
            uploadCSV(e) {
                this.lockCSV = true;
                //  console.log('e.target.files', e.target.files[0]);
                var form = new FormData();
                form.append("skillFile", e.target.files[0]);
                // var params = {
                //
                //   'skillFile' : e.target.files[0]
                // };
                service.post('skill/skillCSV', form, {
                        'Authorization': this.userToken,
                        'Content-Type': 'multipart/form-data',
                        'clientId': this.userClientID,

                    })
                    .then((res) => {
                        // this.status_message = res.data.status_message;
                        // setTimeout(() => {
                        //     this.$modal.hide('add-skill');
                        // }, 500);
                        this.lockCSV = false;
                        this.$notify({
                            title: this.$t('success'),
                            message: 'Skill Added Successfully.',
                            type: 'success'
                        });
                        this.search_query = {
                            'test': 1
                        };
                        this.closeimportCSV();


                    }).catch((err) => {
                        console.log(err);
                        this.lockCSV = false;
                        this.$notify({
                            title: this.$t('error'),
                            message: 'Invalid file format. Please read the instruction before upload.',
                            type: 'error'
                        });
                    })

            },
            searchSkillMethod() {
                this.search_query = this.searchSkill;
            },
            async getSkills() {  
                console.log("Check ViewSkills");              
                await service.get('skill', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                }).then((res) => {
                    this.skills = res.data.result.data;
                    if (this.rateTablesOn) {
                        this.refreshBaseRate();   // #2081 — by table id, not by position
                        return;
                    }
                    this.base_rate = this.skills[0].skill_rates[parseInt(this.selectedRateId)-1].amount;
                }).catch((err) => {
                   console.log(err)
                });
            },

            // ───────────── #2081 — per-client rate tables (flag on only) ─────────────

            /** The base-rate box: the first skill's amount in the selected table. */
            refreshBaseRate() {
                if (!this.rateTablesOn || !this.skills || !this.skills.length) {
                    return;
                }
                this.base_rate = rt.amountFor(this.skills[0], this.selectedRateId);
            },
            rtHeaders() {
                return rt.rateTableHeaders({ userToken: this.userToken, userRole: this.userRole, userClientID: this.userClientID });
            },
            rtPath(suffix) {
                return rt.rateTablesPath(this.userClientID, suffix);
            },
            rtMessage(err, fallback) {
                const d = err && err.response && err.response.data ? err.response.data : null;
                if (d && typeof d.status_message === 'string' && d.status_message) {
                    return d.status_message;
                }
                if (d && d.status_message && typeof d.status_message === 'object') {
                    const first = Object.values(d.status_message)[0];
                    if (Array.isArray(first) && first.length) return String(first[0]);
                }
                return fallback;
            },
            openManageTables() {
                this.manage.error = '';
                this.manage.newAlias = '';
                this.$modal.show('manage-rate-tables');
                this.loadManage();
            },
            closeManageTables() {
                this.$modal.hide('manage-rate-tables');
            },
            /** The client's tables (live + archived). */
            async loadManage() {
                this.manage.busy = true;
                try {
                    const tables = await service.get(this.rtPath('') + '?archived=1', this.rtHeaders());
                    const all = (tables.data && Array.isArray(tables.data.result)) ? tables.data.result : [];
                    this.manage.live = all.filter((t) => !t.archived_at).map((t) => Object.assign({}, t, { saved_alias: t.alias }));
                    this.manage.archived = all.filter((t) => !!t.archived_at);
                } catch (err) {
                    console.log(err);
                    this.manage.error = this.rtMessage(err, 'Rate tables could not be loaded.');
                }
                this.manage.busy = false;
            },
            /** After any change: the modal, the selector and the grid all re-read the server. */
            async afterManageChange(message) {
                await this.loadManage();
                this.getRates();
                this.search_query = { changed: Date.now() };   // RateTable re-reads the skills
                if (message) {
                    this.$notify({ title: this.$t('success'), message: message, type: 'success' });
                }
            },
            async rtCall(fn, okMessage, fallback) {
                this.manage.error = '';
                this.manage.busy = true;
                try {
                    await fn();
                    await this.afterManageChange(okMessage);
                } catch (err) {
                    console.log(err);
                    this.manage.error = this.rtMessage(err, fallback);
                    this.$notify({ title: this.$t('error'), message: this.manage.error, type: 'error' });
                    await this.loadManage();   // put the modal back to what the server has
                }
                this.manage.busy = false;
            },
            addTable() {
                const alias = (this.manage.newAlias || '').trim();
                if (!alias) {
                    this.manage.error = 'Enter an alias for the new table.';
                    return;
                }
                this.rtCall(async () => {
                    await service.post(this.rtPath(''), { alias: alias }, this.rtHeaders());
                    this.manage.newAlias = '';
                }, 'Rate table added.', 'The rate table could not be added.');
            },
            renameTable(t) {
                const alias = (t.alias || '').trim();
                if (!alias || alias === t.saved_alias) {
                    t.alias = t.saved_alias;
                    return;
                }
                this.rtCall(async () => {
                    await service.put(this.rtPath(t.id), { alias: alias }, this.rtHeaders());
                }, 'Rate table renamed.', 'The rate table could not be renamed.');
            },
            moveTable(index, dir) {
                const target = index + dir;
                if (target < 0 || target >= this.manage.live.length) {
                    return;
                }
                const order = this.manage.live.map((t) => t.id);
                const moved = order.splice(index, 1)[0];
                order.splice(target, 0, moved);
                this.rtCall(async () => {
                    await service.put(this.rtPath('reorder'), { order: order }, this.rtHeaders());
                }, 'Rate tables reordered.', 'The rate tables could not be reordered.');
            },
            archiveTable(t) {
                this.$confirm('Archive the rate table "' + t.alias + '"? Its amounts and jobs keep it; it just leaves the lists.', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    this.rtCall(async () => {
                        await service.del(this.rtPath(t.id), this.rtHeaders());
                    }, 'Rate table archived.', 'The rate table could not be archived.');
                }).catch(() => {});
            },
            /**
             * #2081 round 2 — un-archive: the table returns to the live list, last in the order,
             * with its amounts as they were. A live table with the same
             * alias makes the server refuse (409); the message lands in the modal's error line
             * and the error toast, like every other refusal here.
             */
            restoreTable(t) {
                this.rtCall(async () => {
                    await service.put(this.rtPath(t.id + '/restore'), {}, this.rtHeaders());
                }, 'Rate table restored.', 'The rate table could not be restored.');
            },
        }
    }

</script>

<style scoped>
.greyBg {
    background-color: #c5c5c5!important;
    cursor: not-allowed;
    color: #e1e1e1;
}
#update_all:focus {
    color: #ffffff;
    background-color: #1AB677;
}
.p-0{
    padding:0!important;
}
.mr-10{
    margin-right:10px;
}
/* #2081 — manage rate tables modal */
.rt-row .rt-alias { display: inline-block; width: 70%; }
.rt-row .rt-rename { margin-left: 6px; }
.rt-up, .rt-down { margin: 0 6px; font-size: 16px; }
.rt-disabled { opacity: 0.3; pointer-events: none; }
.rt-error { display: block; margin-bottom: 8px; }
</style>
